/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";
import { themeArr, quizTypeArr } from "../global";
import { ImageUpload } from "../components/imageupload";
import ReactTooltip from "react-tooltip";
import { NotificationManager } from "react-notifications";
import CustomTextEditor from "../components/customtexteditor";
import {quiztypeenum} from "../enums/quiztypeenum";


import { PersonalityForm } from "./personalityform";
import { QueCategoryForm } from "./quecategoryform";



var defaultBackgroundImage = "";



export class QuizSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quiz: this.props.quiz,
      user: this.props.user,
      flagshowPersonalityForm: false,
      selectsize: 10,
      enableCustomTheme: true,
      makedisabled: true,
      btn_start_text: "Start",
      is_company_logo: false,
      selectedQue: this.props.selectedQue,
    };
    this.onChangeBackgroundImage = this.onChangeBackgroundImage.bind(this);
    this.onDeleteBackgroundImage = this.onDeleteBackgroundImage.bind(this);
    this.onFieldChanged = this.onFieldChanged.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.checkboxUpgradePlan = this.checkboxUpgradePlan.bind(this);
    this.showPersonalityForm = this.showPersonalityForm.bind(this);
    this.closePersonalityForm = this.closePersonalityForm.bind(this);
    this.upgradeMessage = this.upgradeMessage.bind(this);
    this.companyLogoUpload = this.companyLogoUpload.bind(this);
    this.companyLogoDelete = this.companyLogoDelete.bind(this);
    this.handleEditorValueChange = this.handleEditorValueChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ quiz: nextProps["quiz"], user: nextProps["user"] });
  }
  onFieldChanged(e) {
    if (e.target.name == "theme" && e.target.value === "custom_theme") {
      var tempquizobj = this.state.quiz;
      var name = e.target.name;
      tempquizobj[name] = e.target.value;
      tempquizobj["enableCustomTheme"] = true;
      this.setState({ quiz: tempquizobj }, () => {
        this.props.updateQuiz(tempquizobj);
      });
      return false;
    }
    if (e.target.name == "btn_start_text") {
      this.setState({
        btn_start_text: e.target.value,
      });
    }
    var tempquizobj = this.state.quiz;
    if (tempquizobj == null) {
      tempquizobj = {};
    }
    var name = e.target.name;
    tempquizobj[name] = e.target.value;
    // if (e.target.name == "theme" && e.target.value != "custom_theme") {
    //   tempquizobj["enableCustomTheme"] = false;
    // }
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
    // for company logo
    if (e.target.name == "is_company_logo") {
      tempquizobj["is_company_logo"] = e.target.checked;
      this.setState(
        { quiz: tempquizobj, is_company_logo: e.target.checked },
        () => {
          this.props.updateQuiz(tempquizobj);
        }
      );
    }
  }

  onCheckboxChange(e) {
    var tempquizobj = this.state.quiz;
    var name = e.target.name;
    tempquizobj[name] = e.target.checked;
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
  }
  showPersonalityForm() {
    this.setState({ flagshowPersonalityForm: true });
  }
  closePersonalityForm() {
    this.setState({ flagshowPersonalityForm: false });
  }

  onChangeBackgroundImage(imgtype, imgid, imgpath) {
    var tempquizobj = this.state.quiz;
    tempquizobj.backgroundimg = imgpath;
    this.setState({ quiz: tempquizobj, bgimg: imgpath }, () => {
      //swal("Image Upload", "Image uploaded successfully", "success");
      NotificationManager.success(
        "Image Upload",
        "Image uploaded successfully"
      );
      this.props.updateQuiz(tempquizobj);
    });
  }
  companyLogoUpload(imgtype, imgid, imgpath) {
    var tempquizobj = this.state.quiz;
    tempquizobj.companylogo = imgpath;
    this.setState({ quiz: tempquizobj, bgimg: imgpath }, () => {
      NotificationManager.success(
        "Image Upload",
        "Image uploaded successfully"
      );
      this.props.updateQuiz(tempquizobj);
    });
  }

  companyLogoDelete(imgtype, imgid, imgpath) {
    var tempquizobj = this.state.quiz;
    tempquizobj.companylogo = "";
    this.setState({ quiz: tempquizobj }, () => {
      //swal("Image Delete", "Image deleted successfully", "success");
      NotificationManager.success("Image Delete", "Image deleted successfully");
      this.props.updateQuiz(tempquizobj);
    });
  }

  onDeleteBackgroundImage(imgtype, imgid, imgpath) {
    var tempquizobj = this.state.quiz;
    // tempquizobj.backgroundimg = imgpath;
    tempquizobj.backgroundimg = defaultBackgroundImage;
    this.setState({ quiz: tempquizobj }, () => {
      //swal("Image Delete", "Image deleted successfully", "success");
      NotificationManager.success("Image Delete", "Image deleted successfully");
      this.props.updateQuiz(tempquizobj);
    });
  }

  upgradeMessage() {
    if (this.state.user.mode == "free") {
      this.setState({
        messageUpgrade: "Upgrade your plan to use this feature",
        quizfootermsg: "Powered By Quizzes4Leads",
        makedisabled: true,
      });
    } else {
      this.setState({
        messageUpgrade: null,
        quizfootermsg: "",
        makedisabled: false,
      });
    }
  }
  checkboxUpgradePlan() {
    if (this.state.user.mode == "free") {
      this.setState({
        messageUpgradechecbox: "Upgrade your plan to use this feature",
        makedisabledCheckbox: true,
      });
    }
  }

  renderthemes() {
    if (this.state.quiz.theme != "" || this.state.quiz.theme != "undefined") {
      var self = this;
      return themeArr.map(function (theme, counter) {
        return (
          <option
            defaultValue={theme.value}
            key={counter}
            value={theme != null ? theme.value : null}
            selected={self.state.quiz.theme == theme.value}
          >
            {theme.name}
          </option>
        );
      }, this);
    }
  }
  renderQuizType() {
    var self = this;
    return quizTypeArr.map(function (quiztype, counter) {
      return (
        <option
          key={counter}
          value={quiztype.value}
          selected={
            self.state.quiz != null &&
            self.state.quiz.quiztype == quiztype.value
              ? true
              : false
          }
        >
          {quiztype.name}
        </option>
      );
    }, this);
  }
  handleEditorValueChange(value, fieldname, color) {
    var tempquizobj = this.state.quiz;
    var name = fieldname;
    tempquizobj[name] = value;
    // if has color than only update
    if (color) {
      tempquizobj["welcome_message_color"] = color;
    }
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
  }
  render() {
    return (
      <div style={{ backgroundColor: "white" }}>
        <div className="col-md-12">
          <div name="frmqzsettings" noValidate="">
            <div className="row">
              <div className="col-md-12">
                <div className="form-group has-feedback">
                  <div className="Sign-In-Label">
                    Quiz Title{" "}
                    <i
                      data-tip="Add an attractive title for your quiz."
                      className="fa fa-info-circle"
                    ></i>
                  </div>
                  <CustomTextEditor
                    fieldname={"title"}
                    value={
                      this.state.quiz != null ? this.state.quiz.title : null
                    }
                    placeholder={`${
                      (this.state.quiz != null &&
                        this.state.quiz.quiztype == quiztypeenum.personality_quiz) ||
                      this.state.quiz.quiztype == quiztypeenum.multiple_personality_quiz
                        ? "Eg : What Personality type are you?"
                        : "Eg : How good are you in grade 5 mathematics?"
                    }`}
                    onEditorValueChange={this.handleEditorValueChange}
                  />
                  <span className="help-block error-block basic-block">
                    Required
                  </span>
                </div>
                <ReactTooltip />
                <div className="checkbox">
                  <div className="Sign-In-Label">
                    <div
                      className="col-md-12"
                      style={{ marginLeft: 5, height: 20 }}
                    >
                      <input
                        type="checkbox"
                        onChange={this.onCheckboxChange}
                        name="is_enable_quiz_title"
                        checked={
                          this.state.quiz == null ||
                          this.state.quiz.is_enable_quiz_title == "1"
                            ? true
                            : false
                        }
                      />
                      <div>
                        <span>Enable quiz title on question ?</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="Sign-In-Label">
                    Welcome Message{" "}
                    <i
                      data-tip="Expand on your title to share what is your quiz about?"
                      className="fa fa-info-circle"
                    ></i>
                  </div>
                  <CustomTextEditor
                    fieldname={"quizwelcomemsg"}
                    value={
                      this.state.quiz != null
                        ? this.state.quiz.quizwelcomemsg
                        : ""
                    }
                    placeholder={`${
                      (this.state.quiz != null &&
                        this.state.quiz.quiztype == quiztypeenum.personality_quiz) ||
                      this.state.quiz.quiztype == quiztypeenum.multiple_personality_quiz
                        ? "Eg: Always wondered what type of person you were and where you fit? "
                        : "Eg: Test your mathematic skills and compete with grade 5."
                    }`}
                    onEditorValueChange={this.handleEditorValueChange}
                  />
                  <span className="help-block error-block basic-block">
                    Proper email required
                  </span>
                </div>
                {this.state.user != null && this.state.user.mode == "free" ? (
                  <div className="form-group">
                    <div
                      className="Sign-In-Label"
                      disabled={this.state.user.mode == "free" ? true : false}
                    >
                      Quiz Footer
                    </div>
                    <input
                      name="quizfootermsg"
                      className="Sign-In-TextBox"
                      id="qzfootermsg"
                      required
                      type="text"
                      placeholder="Footer Message"
                      onChange={this.onFieldChanged}
                      onClick={this.upgradeMessage}
                      value={
                        this.state.quiz != null &&
                        this.state.quiz.quizfootermsg != null &&
                        this.state.quiz.quizfootermsg != ""
                          ? this.state.quiz.quizfootermsg
                          : "Powered By Quizzes4Leads"
                      }
                      disabled={this.state.makedisabled}
                    />
                    <p className="upgrade_error">{this.state.messageUpgrade}</p>
                    <span className="help-block error-block basic-block">
                      Required
                    </span>
                  </div>
                ) : null}
                <div className="form-group" onClick={this.checkboxUpgradePlan}>
                  {/* <div className="checkbox">
                    <div className="Sign-In-Label" style={{ marginTop: "0" }}>
                      <div
                        className="col-md-12"
                        style={{ marginLeft: 5, height: 20 }}
                      >
                        <input
                          type="checkbox"
                          onChange={this.onCheckboxChange}
                          name="randomque"
                          // disabled={this.state.user.mode == "free" ? true : false}
                          disabled={this.state.makedisabledCheckbox}
                          title={
                            this.state.user.mode == "free"
                              ? "This is a paid feature"
                              : "This will present questions in random order to player"
                          }
                          checked={
                            this.state.quiz == null ||
                              this.state.quiz.randomque == "1"
                              ? true
                              : false
                          }
                        />
                        <div>
                          <span>Randomize Questions</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="checkbox">
                    <div className="Sign-In-Label">
                      <div
                        className="col-md-12"
                        style={{ marginLeft: 5, height: 20 }}
                      >
                        <input
                          type="checkbox"
                          onChange={this.onCheckboxChange}
                          name="randomans"
                          disabled={this.state.makedisabledCheckbox}
                          title={
                            this.state.user.mode == "free"
                              ? "This is a paid feature"
                              : "This will present answers in random order to player"
                          }
                          checked={
                            this.state.quiz == null ||
                            this.state.quiz.randomans == "1"
                              ? true
                              : false
                          }
                        />
                        <div>
                          <span>Randomize Answers</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="checkbox">
                    <div className="Sign-In-Label">
                      <div
                        className="col-md-12"
                        style={{ marginLeft: 5, height: 20 }}
                      >
                        <input
                          type="checkbox"
                          onChange={this.onCheckboxChange}
                          name="negativeMarking"
                          // disabled={this.state.user.mode == "free" ? true : false}
                          disabled={this.state.makedisabledCheckbox}
                          title={
                            this.state.user.mode == "free"
                              ? "This is a paid feature"
                              : "This will present answers in random order to player"
                          }
                          checked={
                            this.state.quiz == null ||
                              this.state.quiz.negativeMarking == "1"
                              ? true
                              : false
                          }
                        />
                        <div>
                          <span>Negative Marking</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <p className="upgrade_error">
                    {this.state.messageUpgradechecbox}
                  </p>
                </div>
                {/* <div className="form-group">
                  <div className="Sign-In-Label theme_block">
                    {" "}
                    Select Quiz Theme
                  </div>
                  <select
                    tabIndex="-98"
                    title="Category"
                    style={{ marginTop: 8 }}
                    className="form-control Sign-In-TextBox"
                    selectpicker=""
                    onChange={this.onFieldChanged}
                    name="theme"
                  >
                    {this.renderthemes()}
                  </select>
                </div> */}
                <ImageUpload
                  basepath={this.props.basepath}
                  userid={this.props.user.userid}
                  quizid={
                    this.state.quiz != null ? this.state.quiz.quizid : null
                  }
                  imgtype="quizbkgroundimage"
                  title="Upload Quiz Background Image"
                  uploaded_uri=""
                  imagePreviewFlag={true}
                  info_text="Preferred image size 1920x1075"
                  imagepath={
                    this.state.quiz.backgroundimg != null
                      ? this.state.quiz.backgroundimg
                      : this.state.quiz.quizbkgroundimage
                  }
                  onImageUploadComplete={this.onChangeBackgroundImage}
                  onImageDeleteComplete={this.onDeleteBackgroundImage}
                />
                <div class="form-group">
                  <div class="Sign-In-Label" disabled="">
                    Button Text
                  </div>
                  <input
                    maxLength="15"
                    name="btn_start_text"
                    onChange={this.onFieldChanged}
                    class="Sign-In-TextBox"
                    type="text"
                    value={
                      this.state.quiz.btn_start_text
                        ? this.state.quiz.btn_start_text
                        : this.state.btn_start_text
                    }
                  />
                  <div className="counter-wrapper">
                    <span>
                      {this.state.quiz.btn_start_text != null
                        ? this.state.quiz.btn_start_text.length
                        : "0"}
                      /15
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <div class="Sign-In-Label" disabled="">
                    Company Logo{" "}
                    <input
                      onChange={this.onFieldChanged}
                      name="is_company_logo"
                      checked={
                        this.state.is_company_logo
                          ? this.state.is_company_logo
                          : this.state.quiz.is_company_logo
                          ? true
                          : false
                      }
                      type="checkbox"
                    />
                  </div>
                  {/* Show image upload option only when enable company logo */}
                  {this.state.is_company_logo ||
                  this.state.quiz.is_company_logo ? (
                    <div className="company-log-quiz-edit">
                      <img src={this.state.quiz.companylogo} />
                      <i
                        data-tip={
                          "To change company logo, go to account</a> tab."
                        }
                        className="fa fa-info-circle"
                      ></i>
                      <ReactTooltip html={true} />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/*this.state.quiz != null && this.state.quiz.quiztype == quiztypeenum.personality_quiz ? (
                  <button
                    className="btn btn-default cpq"
                    onClick={this.showPersonalityForm}
                  >
                    {" "}
                    Create Personality
                  </button>
                ) : null*/}
                {this.state.quiz != null &&
                (this.state.quiz.quiztype == quiztypeenum.personality_quiz ||
                  this.state.quiz.quiztype == quiztypeenum.multiple_personality_quiz )?(
                  //|| this.state.quiz.quiztype == quiztypeenum.category_quiz_multiple_personality  || this.state.quiz.quiztype == quiztypeenum.category_graded_quiz_with_personality) ? (
                  <PersonalityForm
                    quiz={this.state.quiz}
                    showForm={this.state.flagshowPersonalityForm}
                    closeForm={this.closePersonalityForm}
                    updateQuiz={this.props.updateQuiz}
                    basepath={this.props.basepath}
                  />
                ) : null}
                {this.state.quiz != null && (this.state.quiz.quiztype == quiztypeenum.category_quiz_multiple_personality || this.state.quiz.quiztype ==quiztypeenum.category_graded_quiz_with_personality) ? (
                  <QueCategoryForm
                    quiz={this.state.quiz}
                    showForm={this.state.flagshowQueCategoryForm}
                    closeForm={this.closeQueCategoryForm}
                    updateQuiz={this.props.updateQuiz}
                    basepath={this.props.basepath}
                  />
                ) : null}
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}





